interface CustomerAccount {
    show_onboarding?: boolean | null | undefined;
}

export function loginRedirectRoute(customerAccount: CustomerAccount, redirectTo?: string | null) {
    if (redirectTo) {
        return redirectTo;
    }
    if (customerAccount.show_onboarding) {
        return '/onboarding';
    }
    return '/';
}
